import { render, staticRenderFns } from "./index.vue?vue&type=template&id=da70b350&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=da70b350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da70b350",
  null
  
)

export default component.exports